
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import {getUSTripDetailsApi}  from "@/api/ustripmonitor";



export default defineComponent({
  name: "ustripmonitoring",
  components: {
  },
  data() {
    return { 
      list : [],
      personalPoints : 0.0000,
      loading : false,
      isOverallOK : false
      

    }
  },
  mounted(){
      this.getUSTripDetails();
  },
  methods : {
    async getUSTripDetails(){ 
      this.loading = true;
      const response = await getUSTripDetailsApi(1);
      this.loading = false;

     
      if(response.data.pageList != undefined && response.data.pageList != null){
        this.list = response.data.pageList;
      }

      if(response.data.ustripPersonalPoints != undefined && response.data.ustripPersonalPoints != null){
        this.personalPoints = response.data.ustripPersonalPoints;
      }

      if(response.data.isUSTripOverallStatusOK != undefined && response.data.isUSTripOverallStatusOK != null){
        this.isOverallOK = response.data.isUSTripOverallStatusOK;
      }
    },
   
    
  },
  setup() {
    const tabIndex = ref(0);

    onMounted(() => {
      // set the tab from previous
      tabIndex.value = parseInt(localStorage.getItem("autoPMATab") || "0");
      setCurrentPageTitle("US Trip Monitoring");

    });
    
  }
});
